import { useMutation, useQueryClient } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { toast } from 'sonner';
import type { EstimatePricingOverrides } from '@/utils/pricing/mergeEstimatePricing';

/**
 * Salva gli override di pricing per-preventivo su estimates.pricing_overrides.
 * Passare un oggetto con SOLO le chiavi valorizzate: le chiavi assenti (o messe
 * a null dal chiamante) ereditano dal default org. Se l'oggetto risulta vuoto,
 * salviamo NULL (nessun override → tutto dall'org).
 */
export function useUpdateEstimatePricingOverrides(estimateId: string) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (overrides: EstimatePricingOverrides) => {
      const clean: EstimatePricingOverrides = {};
      for (const [k, v] of Object.entries(overrides)) {
        if (v != null && Number.isFinite(Number(v))) {
          (clean as Record<string, number>)[k] = Number(v);
        }
      }
      const payload = Object.keys(clean).length > 0 ? clean : null;
      const { error } = await supabase
        .from('estimates')
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        .update({ pricing_overrides: payload } as any)
        .eq('id', estimateId);
      if (error) throw error;
      return payload;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['estimate', estimateId] });
      queryClient.invalidateQueries({ queryKey: ['estimate'] });
      toast.success('Pricing preventivo aggiornato');
    },
    onError: (err: Error) => toast.error(`Errore salvataggio pricing: ${err.message}`),
  });
}
